// extracted by css-extract-rspack-plugin
export default {"borderVertical":"use-table-borders_borderVertical__lUH+S","borderHorizontal":"use-table-borders_borderHorizontal__L7bjC"};